import { useEffect } from 'react'

const useLenisPreventForIubenda = () => {
  useEffect(() => {
    if (typeof window === 'undefined' || !('MutationObserver' in window)) return

    const observer = new MutationObserver(() => {
      const iubModal = document.querySelector('#iubenda-iframe-content')
      if (iubModal && !iubModal.hasAttribute('data-lenis-prevent')) {
        iubModal.setAttribute('data-lenis-prevent', '')
      }
    })

    observer.observe(document.body, {
      childList: true,
      subtree: true
    })

    return () => {
      observer.disconnect()
    }
  }, [])
}

export default useLenisPreventForIubenda
